import type { Asset } from '@/types';
import PickerModal from '@/ui/components/picker-modal';
import TokenPickerOption from '@/ui/components/token-picker-option';
import actions from '@/ui/flux/actions';
import type { AssetSelection } from '@/ui/pages/history/types';

function showFilterTokensModal({
  assets,
  defaultAssets,
}: {
  assets: Asset[];
  defaultAssets?: Asset[];
}): { result: AssetSelection } {
  return actions.modal.show({
    title: 'Filter tokens',
    fullscreen: true,
    reactContent: (
      <PickerModal
        options={assets}
        defaultSelected={defaultAssets}
        getOptionKey={(asset) => asset.name}
        renderOption={(asset) => <TokenPickerOption asset={asset} />}
        multiple
        includeAllOption
        onClose={() => {}} // FIXME: Improve `reactContent` type to avoid having to pass `onClose` here.
      />
    ),
  });
}

export default showFilterTokensModal;
